import {cascade} from "@Common/utils/cascade";
import {unique}  from "@Common/utils/collections";
import {chain}   from "@Common/utils/fs";

import {createSetCredits} from "../common/create-set-credits";

const itemAttr = "voucher";

export const setVouchers = createSetCredits({
    cartAttr: "vouchers",
    collectCredits: (cart) =>
        chain(
            cascade(cart.items, `[*].billingAvailable.${itemAttr}[*]`, (voucher) => voucher.id),
            unique,
            (_) => _.map((id) => ({id})),
        )
    ,
});

